import { Injectable } from '@angular/core';

@Injectable({
    providedIn: "root"
})
export class AnalyticService {
    constructor() { window['rawData'] = []; }

    setAnalytics(contractData) {
        if (contractData) {
            window['rawData'] = contractData;
        }
    }

    notifyAnalytics(eventNm: string = "ReqAppDataReady") {
        // console.log('inside analytics method', typeof window['Bootstrapper']);
        window['analyticsDataReady'] = true;
        try {
            if (typeof window['Bootstrapper'] !== 'undefined') {
                window['Bootstrapper'].ensEvent.trigger(eventNm);
            }
        } catch (error) { }
    }

}
